<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm12 md12>
            <v-card class="pb-0">
              <v-toolbar dark color="primary">
              <v-toolbar-title>Seleccione Dia, Hora, Sede</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-form>
                      <v-autocomplete
                          :items="zonas"
                          prepend-icon="healing"
                          label="Municipio"
                          name="zona"
                          clearable
                          @change="onTurnoZonaChange"
                          >
                          <template slot="no-data">
                            <v-list-tile>
                              Municipio Sin Turno Programado
                            </v-list-tile>
                          </template>
                      </v-autocomplete>

                      <v-autocomplete
                          :items="sedes"
                          prepend-icon="healing"
                          label="Sede"
                          name="sede"
                          clearable
                          @change="onTurnoSedeChange"
                          >
                          <template slot="no-data">
                            <v-list-tile>
                              Sede no Disponible
                            </v-list-tile>
                          </template>
                      </v-autocomplete>

                      <v-autocomplete
                          :items="fechas"
                          prepend-icon="domain"
                          name="fecha"
                          label="Fecha"
                          clearable
                          @change="onFechaChange"
                      >
                        <template slot="no-data">
                            <v-list-tile>
                              Fecha No Disponible
                            </v-list-tile>
                        </template>
                      </v-autocomplete>

                      <v-autocomplete
                          :items="horas"
                          prepend-icon="healing"
                          label="Hora"
                          name="Hora"
                          clearable
                          @change="onHoraChange">
                          <template slot="no-data">
                            <v-list-tile>
                              Hora No Disponible
                            </v-list-tile>
                          </template>
                      </v-autocomplete>
                    
                     
              </v-form>
            </v-card-text>
            <FlashMessage></FlashMessage>
              <v-card-actions class="px-5">
               <v-layout row>
              <v-flex xs12 md6>
                  <v-btn outline block @click="save" :disabled="!valid" color="primary">
                    Apartar Cita
                  </v-btn>
                </v-flex>
               <v-flex xs12 md6>   
                  <v-btn outline block @click="devolver"  color="primary" >
                    Devolver
                  </v-btn>
                  
              </v-flex>
            </v-layout>
            </v-card-actions>
            </v-card>
            </v-flex>
      </v-layout>
    </v-container>
     <v-dialog persistent v-model="dialogSuccess" max-width="560px">
      <v-card>
        <v-card-title class="headline blue darken-1 white--text"  primary-title>
          Cita solicitada con éxito!
        </v-card-title>
        <v-card-text>
          <p>Su cita ha sido apartada </p>
          <p><strong>Señor afiliado en caso de que usted posea bono escolar nos permitimos informar que si este no se encuentra en la zona de retiro se deberá realizar un proceso adicional el cual sera explicado en el momento que se acerque a la sede a realizar el retiro.</strong></p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="closeSuccess"><v-icon class="blue--text text--lighten-2">chevron_right</v-icon>Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="dialogLoading"
        hide-overlay
        persistent
        width="300"
    >
      <v-card color="primary" dark
      >
        <v-card-text>
          Por favor, espere...
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-content>
  

</template>

<script>
  import {turnoService} from "../services/turnoService"
  import {router} from "../router";

  export default {
    data: () => ({
      ele:'',
      elk:'',
      valid: true,
      customfield:'',
      hora:'',
      horas: [],
      servicio:'',
      radios: '',
      mensaje: '',
      datosTurnoKit: '',
      fechas: [],
      fecha: '',
      sede:'',
      sedes: [],
      zonas: [],
      zona: '',
      loading: false,
      dialog: false,
      dialogLoading: false,
      dialogSuccess: false,
      headers: [
        {text: 'Sede', value: 'sede', align: 'center'},
        {text: 'Direccion', value: 'direccion', align: 'center'},
        {text: 'Día', value: 'fecha', align: 'center'},
        {text: 'Tramites', value: 'tramites', align: 'center'},
      ],
      turnoIndex: -1,
      turnoItem: {
        id: '',
        fecha: '',
        sede:'',
        direccion:'',
        hora: '',
        medico: '',
        especialidad: '',
        sede: '',
      },
    }),
    computed: {
      turnos() {
        return this.$store.state.turnos.all
      },
      
      paciente () {
        return this.$store.state.paciente.data
      }

    },
    created() {
      let datosAfiliado = JSON.parse(localStorage.getItem('inte'));
      turnoService.findZonaKit().then(data => this.zonas = data)
    },
    watch: {
      dialog(val) {
        val || this.close()
      },
      dialogLoading(val) {
        val || this.close()
      },
    },
    methods: {
      validarPicoyCedula(numdoc, fecha){
        var serviciosSantaMarta = ['13','7','10','11','12','15','18','4','6','28'];
        var band = false;
        var ultimoDigito = numdoc.substring(numdoc.length-1);
        let diaPicoCedula = JSON.parse(localStorage.getItem('horario'));
        var sede = this.sede.toString();
        console.log("sede:"+ sede);
        if(diaPicoCedula == null) {
          return true;
        }   


        diaPicoCedula.forEach(function(item){ 

        if(item.digito.includes(ultimoDigito) && item.fecha == fecha && serviciosSantaMarta.includes(sede)){
            band=true;
        } 
        if(!serviciosSantaMarta.includes(sede)){
             band=true;
        }

        }); 
        return band;
      },

      onFechaChange(fecha) {
        console.log("limpiar horas, hora");
        this.fecha = fecha;
        this.horas = this.hora = null;
        let datosPaciente = JSON.parse(localStorage.getItem('inte'));
        var documento = null;
        if(Array.isArray(datosPaciente)){
          documento = datosPaciente[0].documento;
        }else{
          documento = datosPaciente.documento;
        }
        /*if(!this.validarPicoyCedula(documento, this.fecha)){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Este dia no permite apartarlo por no tener pico y cedula'})
          return false;
        }*/
        turnoService.findHoraByFecha(this.fecha, this.sede).then(data => this.horas = data);

      },

      onTurnoSedeChange(sede) {
        console.log("limpiar fechas, fecha , horas ,hora");
        console.log("fecha");
        console.log(this.fecha);
        console.log("fechas");
        console.log(this.fechas);
        this.sede = sede;
        this.fecha = null;
        this.fechas = null;
        this.horas = null;
        this.hora = null;
        turnoService.findFechaKit(this.sede).then(data => this.fechas = data);
        
      },

      onHoraChange(hora){
        this.hora = hora;
      },
      
      onTurnoZonaChange(zona){
         this.zona = zona;
         this.fechas = null; 
         this.fecha = null; 
         this.horas = null; this.hora = null;
         let datos = JSON.parse(localStorage.getItem('inte'));
         turnoService.findSedeByZona(this.zona, datos.bono  , datos.codzon).then(data => this.sedes = data);
         this.sede = null;
         console.log("limpiar sedes, sede, fechas, fecha, horas, hora");
      }, 
      
      reservarTurno(item) {
        console.log("reservarTurno");
        this.radios = [];
        this.turnoIndex = this.turnos.indexOf(item)
        this.turnoItem = Object.assign({}, item)
        let fec = new Date(this.turnoItem.fecha);
        console.log(fec.getDay());
        
    let citas={}
    var horas=this.turnoItem.hora.split(',');
    for(var hora in horas){
      citas[horas[hora].split('_')[1]] = citas[horas[hora].split('_')[1]] || [];
      citas[horas[hora].split('_')[1]].push(horas[hora].split('_')[0]);
      citas[horas[hora].split('_')[1]].sort(function (a, b) {
        if (a.valor > b.valor) {
          //return 1;
          return Math.floor(-1 + Math.random()*(3));
        }
        if (a.valor < b.valor) {
          //return -1;
          return Math.floor(-1 + Math.random()*(3));
        }
        //return 0;
        return Math.floor(-1 + Math.random()*(3));
      }); 
    }
    var sortable = [];
    for (var cita in citas) {
      sortable.push([cita, citas[cita]]);
    }

    sortable.sort(function(a, b) {
      return a[0].replace(':','') - b[0].replace(':','');
    });

    var result = {}
    sortable.forEach(function(item){
      result[item[0]]=item[1];
    })
         console.log(result);
     
         this.ele = result;
         this.dialog = true
      },
      close() {
        this.dialog = false
      },
      closeSuccess() {
        this.dialogSuccess = false
        router.push('/')
      },
      devolver() {
          localStorage.clear();
          router.push('/');
      },
      save() {
        //let diaPicoCedula = JSON.parse(localStorage.getItem('horario'));
        let datosPaciente = JSON.parse(localStorage.getItem('inte'));
        var pacienteId = null;
        var documento = null;
        var celular = null;
        var email =  null;
        var codins = null;
        if(Array.isArray(datosPaciente)){
          documento = datosPaciente[0].documento;
          celular = datosPaciente[0].celular;
          email = datosPaciente[0].email;  
          codins = datosPaciente[0].codins;
        }else{
          documento = datosPaciente.documento;
          celular = datosPaciente.celular;
          email = datosPaciente.email;
          codins = datosPaciente.codins;
        }

        console.log(this.hora);
        let t = this.hora;
        /*if(!this.validarPicoyCedula(documento, this.fecha)){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Este dia no permite apartarlo por no tener pico y cedula'+t})
          return false;
        }*/

        
        if(!t){
          this.flashMessage.show({status: 'error', title: 'Error', message: 'Debe seleccionar un hora!!'+t})
          return false;
        }
        this.dialogLoading = true;

        turnoService.reservarTurno(t, documento, celular, email,13, codins).then(
          data => {
           if(data.status==200 && data.data.success){
              this.dialogLoading = false;
              this.dialogSuccess = true;
               setTimeout(function(){
                  localStorage.setItem('inte',null);
                  router.push('/');    
                }, 8000); 

            }else{
              this.dialogLoading = false;
              alert(data.data.msj);
            }
          },
          error => {
            console.log("error saving...");
          }
        );
        console.log("close...");
        this.close()
      },
    },
  }
</script>
<style>
  .v-alert {
    margin: 90px 0 90px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/KitCita.vue